export default "__VITE_ASSET__jELhm9dv__"